module.exports = __webpack_public_path__ + "media/images/favicon-b63bc217c2b12a72857ff77b7c6e1ad6.png";